module.exports = __webpack_public_path__ + "static/media/ro.22278e13.svg";